import Config from "Config"
let es
const URL = `${Config.env().API_URL}/events/reschedule/stream`
export function getEventSource() {
   if (!es) {
      es = new EventSource(URL)
   }
   return es
}
